"use client"

import { useState } from "react"
import { Container, Row, Col, Form, FormGroup, Label, Input, Button } from "reactstrap"
import { AlertCircle } from "lucide-react"

export default function AddDispute({update}) {
  const [formData, setFormData] = useState({
    disputeName: "",
    description: "",
    assignedBy: "",
  })

  const [loading, setLoading] = useState(false)

  const handleInputChange = (e) => {
    const { name, value } = e.target
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }))
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    setLoading(true)

    setTimeout(() => {
      console.log("Dispute Type Data:", formData)
      alert("Dispute type added successfully!")
      // Reset form
      setFormData({
        disputeName: "",
        description: "",
        assignedBy: "",
      })
      setLoading(false)
    }, 1500)
  }

  const handleCancel = () => {
    setFormData({
      disputeName: "",
      description: "",
      assignedBy: "",
    })
  }

  return (
      <Container>
        <Row className="justify-content-center">
          <Col lg="8" md="10" xs="12">
            {/* Header Section */}
            <div className="mb-8">
              {update?(<h1 className="text-4xl font-bold text-black mb-2">Update Dispute Type</h1>):<h1 className="text-4xl font-bold text-black mb-2">Add Dispute Type</h1>}
              <p className="text-black text-lg">Define and categorize dispute types in your organization</p>
            </div>

            {/* Main Form Card */}
            <div className="bg-white border border-gray-200 rounded-lg p-4 shadow-sm">
              <Form onSubmit={handleSubmit}>
                {/* Dispute Info Icon Section */}
                <div className="mb-4 pb-4 border-b border-gray-200">
                  <div className="d-flex gap-3 align-items-center">
                    <div
                      className="bg-gray-100 rounded-lg p-3 d-flex align-items-center justify-content-center"
                      style={{ width: "50px", height: "50px" }}
                    >
                      <AlertCircle size={24} className="text-black" />
                    </div>
                    <div>
                      <p className="text-black font-semibold mb-0">Dispute Type Details</p>
                      <p className="text-black text-sm mb-0">Create and manage dispute categories</p>
                    </div>
                  </div>
                </div>

                {/* Dispute Name Row */}
                <Row className="mb-5">
                  <Col md="12">
                    <FormGroup>
                      <Label for="disputeName" className="text-black font-semibold mb-2">
                        Dispute Name <span className="text-red-500">*</span>
                      </Label>
                      <Input
                        type="text"
                        name="disputeName"
                        id="disputeName"
                        placeholder="Enter dispute type name (e.g., Payment Dispute, Quality Issue)"
                        value={formData.disputeName}
                        onChange={handleInputChange}
                        required
                        className="border-gray-300 py-2 px-3"
                        style={{ borderColor: "#e5e7eb" }}
                      />
                    </FormGroup>
                  </Col>
                </Row>

                {/* Description Row */}
                <Row className="mb-5">
                  <Col md="12">
                    <FormGroup>
                      <Label for="description" className="text-black font-semibold mb-2">
                        Description <span className="text-red-500">*</span>
                      </Label>
                      <Input
                        type="textarea"
                        name="description"
                        id="description"
                        placeholder="Provide a detailed description of this dispute type"
                        value={formData.description}
                        onChange={handleInputChange}
                        required
                        rows={5}
                        className="border-gray-300 py-2 px-3"
                        style={{ borderColor: "#e5e7eb", resize: "none" }}
                      />
                    </FormGroup>
                  </Col>
                </Row>

                {/* Assigned By Row */}
                <Row className="mb-5">
                  <Col md="12">
                    <FormGroup>
                      <Label for="assignedBy" className="text-black font-semibold mb-2">
                        Assigned By <span className="text-red-500">*</span>
                      </Label>
                      <Input
                        type="select"
                        name="assignedBy"
                        id="assignedBy"
                        value={formData.assignedBy}
                        onChange={handleInputChange}
                        required
                        className="border-gray-300 py-2 px-3"
                        style={{ borderColor: "#e5e7eb" }}
                      >
                        <option value="">Select assigned by</option>
                        <option value="admin">System Admin</option>
                        <option value="manager">Legal Department</option>
                        <option value="hr">Operations Team</option>
                        <option value="legal">Audit Department</option>
                        <option value="compliance">Fraud Investigation</option>
                      </Input>
                    </FormGroup>
                  </Col>
                </Row>

                {/* Action Buttons */}
                <div className="d-flex gap-3 justify-content-end pt-6 border-t border-gray-200">
                  <Button
                    type="button"
                    color="light"
                    className="px-6 py-2 font-semibold text-black border border-gray-300"
                    onClick={handleCancel}
                    disabled={loading}
                  >
                    Cancel
                  </Button>
                  <Button
                    type="submit"
                    color="dark"
                    className="px-6 py-2 font-semibold bg-black text-white"
                    disabled={loading}
                  >
                    {loading ? "Submitting..." : "Submit"}
                  </Button>
                </div>
              </Form>
            </div>

            {/* Footer Info */}
            <div className="mt-6 text-center text-gray-500 text-sm">
              <p>
                All fields marked with <span className="text-red-500">*</span> are required
              </p>
            </div>
          </Col>
        </Row>
      </Container>
  )
}
